import * as React from 'react';
import './style.scss';
import { SanitizerService } from '../../../services/sanitizer.service';

function SubmitSuccessfulComponent({ children, successText }: { children?: React.ReactNode; successText?: string }) {
  return (
    <div className="submit-successful">
      <div className="circle__box">
        <div className="circle__wrapper circle__wrapper--right">
          <div className="circle__whole circle__right"></div>
        </div>
        <div className="circle__wrapper circle__wrapper--left">
          <div className="circle__whole circle__left"></div>
        </div>
        <div className="circle__checkmark"></div>
      </div>
      {children}
      {successText && (
        <div className="submit-successful__completed-info mb-4">
          <div dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(successText) }}></div>
        </div>
      )}
    </div>
  );
}

export default SubmitSuccessfulComponent;
